/* Bundomanija — mali pomoćni skript: animacija pojavljivanja i odbrojavanje */
(function () {
  function initFade(root) {
    var els = (root || document).querySelectorAll('.bm-fade:not(.is-visible)');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function initCountdowns(root) {
    (root || document).querySelectorAll('[data-bm-countdown]').forEach(function (el) {
      if (el.dataset.bmReady) return;
      el.dataset.bmReady = '1';
      var section = el.closest('[data-bm-countdown-section]');
      var d = el.querySelector('[data-d]'), h = el.querySelector('[data-h]'),
          m = el.querySelector('[data-m]'), s = el.querySelector('[data-s]');
      var loopHours = parseFloat(el.getAttribute('data-bm-loop') || '0');
      var end = null;
      if (!(loopHours > 0)) {
        var raw = (el.getAttribute('data-bm-countdown') || '').trim().replace(' ', 'T');
        end = new Date(raw);
        if (isNaN(end.getTime())) { el.hidden = true; return; }
      }
      function tick() {
        var diff;
        if (loopHours > 0) {
          /* tajmer u krug: svakih X sati kreće ispočetka, isto vreme za sve posetioce */
          var cycle = Math.round(loopHours * 3600000);
          diff = cycle - (Date.now() % cycle);
        } else {
          diff = Math.max(0, end.getTime() - Date.now());
        }
        var sec = Math.floor(diff / 1000);
        if (d) {
          d.textContent = pad(Math.floor(sec / 86400));
          if (h) h.textContent = pad(Math.floor((sec % 86400) / 3600));
        } else if (h) {
          h.textContent = pad(Math.floor(sec / 3600));
        }
        if (m) m.textContent = pad(Math.floor((sec % 3600) / 60));
        if (s) s.textContent = pad(sec % 60);
        if (!(loopHours > 0) && diff <= 0) {
          clearInterval(timer);
          if (section && section.dataset.hideExpired === 'true' && !window.Shopify?.designMode) {
            section.hidden = true;
          }
        }
      }
      var timer = setInterval(tick, 1000);
      tick();
    });
  }

  /* Boje na karticama: klik / prelazak mišem menja sliku i link kartice */
  function selectSwatch(btn) {
    var wrap = btn.closest('.card-wrapper') || btn.closest('.card');
    if (!wrap) return;
    wrap.querySelectorAll('.bm-swatch').forEach(function (b) {
      b.classList.toggle('is-active', b === btn);
    });
    var img = wrap.querySelector('.card__media .media img');
    if (img && btn.dataset.srcset) {
      img.srcset = btn.dataset.srcset;
      img.src = btn.dataset.src;
    }
    wrap.classList.add('bm-swatched');
    if (btn.dataset.url) {
      wrap.querySelectorAll('a.full-unstyled-link, .card__media a').forEach(function (a) {
        a.href = btn.dataset.url;
      });
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.bm-swatch');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    selectSwatch(btn);
  });

  var canHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  if (canHover) {
    document.addEventListener('mouseover', function (e) {
      var btn = e.target.closest && e.target.closest('.bm-swatch');
      if (btn && !btn.classList.contains('is-active')) selectSwatch(btn);
    });
  }

  function init(root) { initFade(root); initCountdowns(root); }

  document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
